export default __webpack_public_path__ + "static/media/mind.231e53ae.jpg";